import React, { useState } from 'react';
import { ChevronDown, ShieldCheck } from 'lucide-react';
import { StrategyCompare } from './StrategyCompare';
import { StrategyReportButtons } from './StrategyReportButtons';

const LISTS = [['normas', 'Normas aplicables'], ['riesgos', 'Riesgos'], ['proximos_pasos', 'Próximos pasos'], ['documentos_faltantes', 'Documentos que conviene reunir']];
const APRECIA = { favorable: 'Favorable', incierta: 'Incierta', desfavorable: 'Desfavorable' };

// Initial strategy drafted from the case documents and approved by the lawyer when creating the case
export const IntakeStrategyView = ({ s, history = [], matter }) => {
  const [open, setOpen] = useState(false);
  const [cmp, setCmp] = useState(false);
  const c = s.content || {};
  return (
    <div data-testid="intake-strategy-view" className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-3 text-sm">
      <button type="button" data-testid="intake-strategy-view-toggle" onClick={() => setOpen((v) => !v)} className="flex w-full items-center justify-between gap-2 text-left">
        <span className="font-semibold text-amber-200">Estrategia aprobada{s.version ? ` v${s.version}` : ''} · apreciación {APRECIA[c.apreciacion] || 'incierta'}</span>
        <ChevronDown className={`h-4 w-4 shrink-0 text-amber-300 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <p className="mt-1 flex items-center gap-1 text-[11px] text-slate-400"><ShieldCheck className="h-3 w-3 text-emerald-400" />Revisada por {s.reviewed_by || 'el abogado'} · {String(s.reviewed_at || '').slice(0, 10).split('-').reverse().join('-')}
        {history.length > 0 && <button type="button" data-testid="strategy-compare-toggle" onClick={() => setCmp((v) => !v)} className="ml-2 text-amber-300 underline">{cmp ? 'Ocultar comparación' : `Comparar versiones (${history.length + 1})`}</button>}</p>
      {cmp && <StrategyCompare current={s} history={history} />}
      {matter && <div className="mt-2"><StrategyReportButtons matterId={matter.id} title={matter.title} /></div>}
      {open && (
        <div className="mt-2 space-y-2 text-xs text-slate-300">
          {c.resumen && <p>{c.resumen}</p>}
          {(s.cambios || []).length > 0 && <div><p className="font-semibold text-slate-200">Cambios de esta versión</p><ul className="list-disc pl-4">{s.cambios.map((x, i) => <li key={i}>{x}</li>)}</ul></div>}
          {c.objetivo && <p><b className="text-slate-200">Objetivo:</b> {c.objetivo}</p>}
          {c.fundamento_apreciacion && <p><b className="text-slate-200">Fundamento:</b> {c.fundamento_apreciacion}</p>}
          {(c.lineas || []).map((l, i) => <p key={i}><b className="text-amber-100">{l.titulo}:</b> {l.detalle}</p>)}
          {LISTS.map(([k, label]) => ((c[k] || []).length ? (
            <div key={k}><p className="font-semibold text-slate-200">{label}</p><ul className="list-disc pl-4">{c[k].map((x, i) => <li key={i}>{x}</li>)}</ul></div>
          ) : null))}
        </div>
      )}
    </div>
  );
};
